
// Initialize Swiper on DOMContentLoaded

document.addEventListener('DOMContentLoaded', function() {
  var swiper = new Swiper(".mySwiper", {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    slideToClickedSlide : true,
    breakpoints: {
      1024: {
        slidesPerView: 2,
      },
    },
  });

  var swiper2 = new Swiper(".mySwiper2", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".testimonials-next",
      prevEl: ".testimonials-prev",
    },
    on: {
        afterInit: (swiper) => {
          swiper.thumbs.swiper.params.slideToClickedSlide = true;
          swiper.thumbs.swiper.update();
        },
        realIndexChange: (swiper) => {
          swiper.thumbs.swiper.slideToLoop(swiper.realIndex);
        },
      },
    thumbs: {
      swiper: swiper,
    },
  });

});
